import React from "react";

import { cn } from "@/utils/cn";

import { Avatar, HStack } from "./ui";

interface AvatarStackProps {
  avatars: string[];
  size: number;
  withRing?: boolean;
  containerClassName?: string;
  className?: string;
}

const AvatarStack = ({
  avatars,
  size,
  withRing = false,
  containerClassName,
  className,
}: AvatarStackProps) => {
  if (avatars.length === 0) return null;

  return (
    <HStack space={-2} className={containerClassName}>
      {avatars.map((avatar, index) => (
        <Avatar
          key={index}
          className={cn(
            "relative rounded-full",
            {
              "ring-2 ring-gray-200 dark:ring-gray-900": withRing,
            },
            className,
          )}
          src={avatar}
          size={size}
        />
      ))}
    </HStack>
  );
};

export default AvatarStack;
